/**
 * dual-threshold-bar.js
 */

class DualThresholdBar extends HTMLElement {
  connectedCallback() {
    // Data attributes are on the inner div (.dual-threshold-bar), not the custom element
    const bar = this.querySelector('.dual-threshold-bar');

    this._shipThr = parseInt(bar?.dataset.shippingThreshold, 10) || 0;
    this._giftThr = parseInt(bar?.dataset.giftThreshold,     10) || 0;

    const initialTotal = parseInt(bar?.dataset.total, 10) || 0;
    this._applyState(initialTotal);

    document.addEventListener('theme:cart:updated', () => this._fetchAndUpdate());
    document.addEventListener('cart:refresh',       () => this._fetchAndUpdate());
  }

  async _fetchAndUpdate() {
    try {
      const res  = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      const cart = await res.json();
      this._applyState(cart.total_price);
    } catch (err) {
      console.error('[DualThresholdBar] Could not fetch cart:', err);
    }
  }

  _applyState(total) {
    const shipThr = this._shipThr;
    const giftThr = this._giftThr;

    const shipReached = total >= shipThr;
    const giftReached = total >= giftThr;

    // ── Milestone icons ──
    this.querySelector('.dual-threshold-bar__milestone--shipping')?.classList.toggle('is-reached', shipReached);
    this.querySelector('.dual-threshold-bar__milestone--gift')?.classList.toggle('is-reached', giftReached);

    // ── Progress fill ──
    const fill = this.querySelector('.dual-threshold-bar__fill');
    if (fill && giftThr > 0) {
      const pct = Math.min(100, Math.round((total / giftThr) * 100));
      fill.style.width = pct + '%';
      fill.closest('[role="progressbar"]')?.setAttribute('aria-valuenow', pct);
    }

    // ── Message ──
      const msg = this.querySelector('.dual-threshold-bar__message');

      if (msg) {
        const bar = this.querySelector('.dual-threshold-bar');

        // Liquid formatted values (₹ / $ according to current market on initial render)
        const leftForShipText = bar.dataset.leftForShipping;
        const leftForGiftText = bar.dataset.leftForGift;

        if (giftReached) {
          msg.innerHTML = `🎁 Free gift unlocked! Choose your sample below.`;
        } else if (shipReached) {
          msg.innerHTML = `🚚 Free shipping unlocked! Add ${leftForGiftText} more to get a free gift.`;
        } else {
          msg.innerHTML = `🛒 Add ${leftForShipText} more to get free shipping.`;
        }
      }
  }
}

customElements.define('dual-threshold-bar', DualThresholdBar);

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.free-gift-card__btn');
  if (!btn) return;
  document.querySelectorAll('.free-gift-card').forEach(c => c.classList.remove('is-selected'));
  btn.closest('.free-gift-card')?.classList.add('is-selected');
});